module.exports = __webpack_public_path__ + "img/hangzhixinlogo-baise-wangzhan.4160ef4c.png";